export const messagingKeys = {
  base: ["messages"] as const,
  count: () => [...messagingKeys.base, "count"] as const,
};
